import React from "react";

function MasterChains() {
  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Master Chains</h1>
        <p className="text-gray-700 leading-relaxed text-base">
          <strong>Master</strong> by Lucky Engineers is recognized as the
          largest manufacturer of bicycle chains in India, a reputation earned
          through decades of dedication to quality and innovation. With a
          state-of-the-art manufacturing facility equipped with cutting-edge
          technology and a team of skilled engineers and technicians, the brand
          <strong> MASTER</strong> stands as a symbol of excellence in the
          bicycle component industry.
        </p>
      </div>

      {/* Key Highlights */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Key Highlights
        </h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-2">
          <li>
            <strong className="text-gray-900">Established Legacy:</strong> Nearly
            30 years ago, Lucky Engineers began their journey with a vision to
            revolutionize the cycling experience in India.
          </li>
          <li>
            <strong className="text-gray-900">Commitment to Quality:</strong>{" "}
            MASTER produces high-performance bicycle components that cater to
            the diverse needs of cyclists nationwide.
          </li>
          <li>
            <strong className="text-gray-900">Innovation & R&D:</strong>{" "}
            Continuous investment in research and development has led to chains
            that offer superior durability, efficiency, and smooth operation.
          </li>
          <li>
            <strong className="text-gray-900">Top-Quality Chains:</strong>{" "}
            Specializes in manufacturing top-quality chains for the cycling
            industry, deeply understanding the needs of Indian cyclists.
          </li>
          <li>
            <strong className="text-gray-900">Efficiency & Quality:</strong>{" "}
            MASTER chains are more efficient and on par in quality with leading
            global brands.
          </li>
          <li>
            <strong className="text-gray-900">Pioneering Bushless Chains:</strong>{" "}
            First and only manufacturer of bushless chains in India, having
            fully transitioned to this advanced chain type.
          </li>
          <li>
            <strong className="text-gray-900">
              Coining in Single Speed Chains:
            </strong>{" "}
            Offers “Coining” even in their most basic single-speed chains, a
            feature typically found only in premium single-speed and multi-speed
            chains worldwide.
          </li>
        </ul>
      </div>

      {/* Closing Note */}
      <div className="max-sm:px-4">
        <p className="text-gray-700 text-sm leading-relaxed">
          MASTER by Lucky Engineers has truly revolutionized the bicycle chain
          manufacturing industry in India, setting new standards of quality and
          performance.
        </p>
      </div>
    </div>
  );
}

export default MasterChains;
